import { NgModule } from '@angular/core';
import { ButtonComponent } from './button.component';

/** Import this module in feature NgModules to use `<app-button>` in templates. */
@NgModule({
  imports: [ButtonComponent],
  exports: [ButtonComponent],
})
export class AppButtonModule {}
